import { NavLink } from 'react-router-dom';
import { useAuth } from '@/lib/auth/AuthContext';

interface NavItem {
  path: string;
  label: string;
  icon: string;
}

const navItems: NavItem[] = [
  { path: '/', label: 'Dashboard', icon: '📊' },
  { path: '/outlets', label: 'Outlets', icon: '🏪' },
  { path: '/frames', label: 'Frames', icon: '🖼️' },
  { path: '/frame-categories', label: 'Frame Categories', icon: '🏷️' },
  { path: '/users', label: 'Admins', icon: '👥' },
  { path: '/cashiers', label: 'Cashiers', icon: '💼' },
  { path: '/categories', label: 'Categories', icon: '📁' },
  { path: '/products', label: 'Products', icon: '📦' },
  { path: '/revenue', label: 'Revenue', icon: '💰' },
  { path: '/transactions', label: 'Transactions', icon: '🛒' },
  { path: '/branding', label: 'Branding', icon: '🎨' },
  { path: '/capture', label: 'Capture', icon: '📸' },
  { path: '/vouchers', label: 'Vouchers', icon: '🎫' },
];

interface SidebarProps {
  isOpen: boolean;
  onClose: () => void;
}

export function Sidebar({ isOpen, onClose }: SidebarProps) {
  const { user, logout } = useAuth();

  return (
    <>
      {/* Mobile Overlay */}
      {isOpen && (
        <div
          className="fixed inset-0 z-20 bg-black/50 md:hidden"
          onClick={onClose}
        />
      )}

      {/* Sidebar Container */}
      <div className={`
        fixed inset-y-0 left-0 z-30 w-64 bg-surface border-r border-gray-200 transform transition-transform duration-200 ease-in-out
        md:relative md:translate-x-0
        ${isOpen ? 'translate-x-0' : '-translate-x-full'}
      `}>
        <div className="flex flex-col h-full">
          <div className="p-6 border-b border-gray-200 flex justify-between items-center">
            <div>
              <h1 className="text-xl font-bold text-text">Photo Booth</h1>
              <p className="text-sm text-text-muted mt-1">{user?.username}</p>
            </div>
            {/* Mobile Close Button */}
            <button
              onClick={onClose}
              className="md:hidden text-text-muted hover:text-text"
            >
              ✕
            </button>
          </div>

          <nav className="flex-1 p-4 space-y-1 overflow-y-auto">
            {navItems.map((item) => (
              <NavLink
                key={item.path}
                to={item.path}
                end={item.path === '/'}
                onClick={() => {
                  // Close sidebar on mobile when navigating
                  if (window.innerWidth < 768) {
                    onClose();
                  }
                }}
                className={({ isActive }) =>
                  `flex items-center gap-3 px-4 py-3 rounded-lg transition-colors ${isActive
                    ? 'bg-primary text-white'
                    : 'text-text hover:bg-gray-100'
                  }`
                }
              >
                <span className="text-xl">{item.icon}</span>
                <span className="font-medium">{item.label}</span>
              </NavLink>
            ))}
          </nav>

          <div className="p-4 border-t border-gray-200">
            <button
              onClick={logout}
              className="w-full flex items-center gap-3 px-4 py-3 rounded-lg text-text hover:bg-gray-100 transition-colors"
            >
              <span className="text-xl">🚪</span>
              <span className="font-medium">Logout</span>
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
